/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit ToPart/view.blocks to change it.
import * as fromData from 'Simple/Data'
import * as fromFlow from 'Simple/Flow'
import * as fromHelpers from './helpers.js'
import No from './No/index'
import Priority from './Priority/index'
import React from 'react'
import Tag from './Tag/index'
import TextDisplay from './TextDisplay/index'



/** @type {import('Simple/types.js').View} */
export default function ToPart({
  children,
  viewPath = "/DesignSystem/TasksViewForm/Content/Content/Activities/Content/Activity/ActivityType/Log/ToPart"
  
}) {
  let flowValue = fromFlow.useFlowValue(viewPath) || 'No'
let activityTextpartsTargetValueData = fromData.useDataFormat({ viewPath,
context: 'activity',
path: 'textParts.target',
format: fromHelpers.getView,
})
fromData.useSetFlowToBasedOnDataValue({ viewPath,
value: activityTextpartsTargetValueData,
})
let activityTextpartsToValueData = fromData.useDataValue({ viewPath,
context: 'activity',
path: 'textParts.to',
})
  return (<React.Fragment
>
<fromFlow.When is={flowValue === 'No'}>
<No
  viewPath={`${viewPath}/No`}
/>
</fromFlow.When>
<fromFlow.When is={flowValue === 'TextDisplay'}>
<TextDisplay
  viewPath={`${viewPath}/TextDisplay`}
/>
</fromFlow.When>
<fromFlow.When is={flowValue === 'Tag'}>
<Tag
  viewPath={`${viewPath}/Tag`}
/>
</fromFlow.When>
<fromFlow.When is={flowValue === 'Priority'}>
<Priority
  viewPath={`${viewPath}/Priority`}
 data="activity.textParts.to"
 value={activityTextpartsToValueData}
/>
</fromFlow.When>
{children}
</React.Fragment>)
}